import React, { lazy, Suspense } from 'react';
import LoadingPanel from 'components/Progress/LoadingPanel';
import { useCollection } from 'effects/useCollection';
// import CollectionListItem from './CollectionListItem';

const CollectionListItem = lazy(() => import('./CollectionListItem' /* webpackChunkName: "collectionListItem" */));

const DynamicCollectionListItem: React.FC<{
  collectionHandle: string;
  title: string;
  background: string;
}> = ({ collectionHandle, title, background }) => {
  const { collection, error: collectionError } = useCollection(collectionHandle);
  if (collectionError) return null;
  return <Suspense fallback={<LoadingPanel />}>{collection && <CollectionListItem title={title} item={collection} background={background} />}</Suspense>;
};

export default DynamicCollectionListItem;
